import React from 'react';
import {  exclametry_bg_gray, CorrectTick, exclametry_bg_gray_up, exclametry_red_dark, exclametaryYellowInfoIcon, } from '../../../../assets/images';
import { dsButtonPrimary, joinButtonClasses } from '../../../../utils/buttonStyles';

const bgColor = {'red':'#FDEDEB', 'green':'#E6F3F0', 'blue': '#EFF6FF', 'yellow' : '#FDF1E4'}
const bannerIcons = {'red':exclametry_red_dark, 'green':CorrectTick, 'blue': exclametry_bg_gray_up, 'yellow': exclametaryYellowInfoIcon}

const UserAlert = ({
  icon = 'default',
  /** When set, replaces the default banner image (e.g. design-system inline icon). */
  leadingIcon = null,
  para,
  btntext,
  btnHandler,
  paraClasses = '',
  imgClasses = '',
  classes = '',
  bodyClasses = 'items-center',
}) => {
  return (
    <div className={`rounded-ds-md ${classes}`} style={{ background: bgColor[icon] || '#EFF6FF' }}>
      <div className={`flex ${bodyClasses}`}>
        {leadingIcon ? (
          <span className={`flex shrink-0 items-center justify-center ${imgClasses}`}>{leadingIcon}</span>
        ) : (
          <img
            src={bannerIcons[icon] || exclametry_bg_gray}
            alt='bannere-icon'
            className={imgClasses}
          />
        )}
        <div className='ml-3 flex-1 flex justify-between items-center'>
          <p className={'text-ts-md mb-0 ' + paraClasses}>{para}</p>
          {btntext && (
            <button className={joinButtonClasses(dsButtonPrimary, 'h-10 px-4')} onClick={btnHandler}>
              {btntext}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserAlert;
